module.exports = __webpack_public_path__ + "img/web_3.919d76e2.webp";